import React, { useState } from 'react';
import styled from 'styled-components';
import theme from '../theme';

var Page = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.bgGradient};
  padding: 16px;
`;

var Card = styled.div`
  width: 100%;
  max-width: 400px;
  background: ${theme.bgCard};
  border: 1px solid ${theme.border};
  border-radius: ${theme.radius};
  padding: 32px;
`;

var Title = styled.h1`
  text-align: center;
  color: ${theme.accent};
  font-size: 1.8rem;
  margin-bottom: 8px;
`;

var Subtitle = styled.p`
  text-align: center;
  color: ${theme.textMuted};
  margin-bottom: 24px;
  font-size: 0.9rem;
`;

var Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid ${theme.border};
  border-radius: ${theme.radiusSm};
  background: ${theme.bg};
  color: #fff;
  font-size: 1rem;
  margin-bottom: 12px;
  min-height: 48px;
  &:focus { outline: none; border-color: ${theme.accent}; }
  &::placeholder { color: ${theme.textPlaceholder}; }
`;

var Btn = styled.button`
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: ${theme.radiusSm};
  background: ${theme.accentGradient};
  color: #000;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  min-height: 48px;
  margin-bottom: 12px;
  &:hover { opacity: 0.9; }
`;

var Toggle = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${theme.accent};
  cursor: pointer;
  font-size: 0.85rem;
  padding: 8px;
`;

var Err = styled.div`
  background: rgba(244,67,54,0.1);
  border: 1px solid ${theme.error};
  color: ${theme.error};
  padding: 10px;
  border-radius: ${theme.radiusSm};
  margin-bottom: 12px;
  font-size: 0.85rem;
`;

var LoginPage = function ({ onLogin, onRegister }) {
  var [mode, setMode] = useState('login');
  var [username, setUsername] = useState('');
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [error, setError] = useState('');
  var [loading, setLoading] = useState(false);

  var handleSubmit = async function (e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') await onLogin(username, password);
      else await onRegister(username, email, password);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <Page>
      <Card>
        <Title>🥗 MealPrep</Title>
        <Subtitle>{mode === 'login' ? 'Sign in to your account' : 'Create your account'}</Subtitle>
        <form onSubmit={handleSubmit}>
          {error && <Err>{error}</Err>}
          <Input placeholder="Username" value={username} onChange={function (e) { setUsername(e.target.value); }} />
          {mode === 'register' && (
            <Input placeholder="Email" type="email" value={email} onChange={function (e) { setEmail(e.target.value); }} />
          )}
          <Input placeholder="Password" type="password" value={password} onChange={function (e) { setPassword(e.target.value); }} />
          <Btn type="submit" disabled={loading}>{loading ? '...' : mode === 'login' ? 'Sign In' : 'Create Account'}</Btn>
        </form>
        <Toggle onClick={function () { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }}>
          {mode === 'login' ? "Don't have an account? Register" : 'Already have an account? Sign in'}
        </Toggle>
      </Card>
    </Page>
  );
};

export default LoginPage;
